import { useState } from "react";
import { createRoot } from "react-dom/client";
import { InputWrapper } from "../../../components/inputs/final_form/InputWrapper";
import { safeJSONParse } from "../../../util/helpers";
import { TestSelector } from "../../../components/inputs/TestSelector";

const TestSelectApp = ({ initialTests, isMulti = false, disabled = false, inputName, label, labIds, required = false }) => {
  const [selectedTests, setSelectedTests] = useState(initialTests);

  return (
    <InputWrapper label={label} required={required}>
      <TestSelector isMulti={isMulti} onChange={setSelectedTests} value={selectedTests} disabled={disabled} labIds={labIds} />

      {isMulti ? (
        <select name={inputName} multiple="multiple" style={{ display: "none" }} value={selectedTests} readOnly>
          {selectedTests.map((p) => (
            <option value={p} key={p}>
              {p}
            </option>
          ))}
        </select>
      ) : (
        <input type="hidden" name={inputName} value={selectedTests} />
      )}
    </InputWrapper>
  );
};

export const initTestSelect = () => {
  const selectContainers = Array.from(document.getElementsByClassName("test_selector"));

  selectContainers.forEach(function (container) {
    const root = createRoot(container);
    const { initialTests, labIds, inputName, isMulti, disabled, label, required } = container.dataset;

    root.render(
      <TestSelectApp
        initialTests={safeJSONParse(initialTests)}
        isMulti={safeJSONParse(isMulti)}
        disabled={safeJSONParse(disabled)}
        required={safeJSONParse(required)}
        labIds={safeJSONParse(labIds)}
        inputName={inputName}
        label={label}
      />
    );
  });
};
